// extracted by mini-css-extract-plugin
module.exports = {"header":"text_header___ftQ_","body":"text_body__Mb96J"};